import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/Inicio'; // Importamos tu página de promoción
import Login from './components/Login';        // Importamos el nuevo login azul
import Dashboard from './components/Dashboard'; // <-- 1. IMPORTAR AQUÍ
import Alumnos from './components/Alumnos'; // <-- 1. IMPORTAR AQUÍ
import Matriculas from './components/Matriculas';
import Calificaciones from './components/Calificaciones';
import Cursos from './components/Cursos';
import Aulas from './components/Aulas';
import Criterios from './components/Criterios';
import Asistencias from './components/Asistencias'; // <-- Importar arriba
import Personal from './components/Personal';
import Boletas from './components/Boletas'; // Añade esto arriba
import Apoderados from './components/Apoderados';
import Caja from './components/Caja';

import Comunicados from './components/Comunicados';

// En tu App.js (Ejemplo)
import PanelSuperAdmin from './components/PanelSuperAdmin';
// Arriba, en tus importaciones:
import Auditoria from './components/Auditoria'; // Asegúrate de que la ruta sea correcta

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/alumnos" element={<Alumnos />} /> {/* <-- 2. AGREGAR ESTA LÍNEA */}
          <Route path="/matriculas" element={<Matriculas />} />
          <Route path="/calificaciones" element={<Calificaciones />} />
          <Route path="/cursos" element={<Cursos />} />
          <Route path="/aulas" element={<Aulas />} />
          <Route path="/criterios" element={<Criterios />} />

        <Route path="/asistencias" element={<Asistencias />} />
        <Route path="/caja" element={<Caja />} />
        <Route path="/personal" element={<Personal />} />
        <Route path="/boletas" element={<Boletas />} />
        <Route path="/apoderados" element={<Apoderados />} />

        <Route path="/comunicados" element={<Comunicados />} />

        <Route path="/sysadmin" element={<PanelSuperAdmin />} />

        <Route path="/auditoria" element={<Auditoria />} />

        </Routes>
      </div>
    </Router>
  );
}

export default App;
